import TlStaffSelect from "./src/index.vue";

TlStaffSelect.install = function (Vue) {
  Vue.component(TlStaffSelect.name, TlStaffSelect);
};

export default TlStaffSelect;
